import { WebBodyText18, WebHeading28 } from '@fintronners/react-ui/src/GlobalStyling/webTypography';
import React, { MouseEventHandler } from 'react';
import Image from 'next/image';
import { SuccessCircleIcon } from '~assets/icons';
import { Button } from '@/components/common/Button';
import { SheetContent, SheetFooter, SheetTitle } from '@/components/common/Sheet';
import { useTranslation } from 'react-i18next';

interface FixedIncomeTradeSuccessProps {
  onClose?: MouseEventHandler;
}

/**
 * Fixed Income Trade Success Component
 *
 * This component displays a success message after a fixed income trade has been successfully executed.
 * It includes a congratulatory message and a button to close the success panel.
 */
export const FixedIncomeTradeSuccess = ({ onClose }: FixedIncomeTradeSuccessProps) => {
  const { t } = useTranslation();

  return (
    <SheetContent>
      <div className="flex flex-col items-center gap-7 text-center mt-20">
        <Image alt="Success icon" width={50} height={50} src={SuccessCircleIcon.src} />

        <SheetTitle>
          <WebHeading28.Bold className="text-darkestBlue">
            {t('common.congratulations')}!
          </WebHeading28.Bold>
        </SheetTitle>

        <WebBodyText18.Regular className="text-grey72">
          {t('common.checkYourActivityHistory')}
        </WebBodyText18.Regular>
      </div>

      <SheetFooter className="text-center mb-5">
        <Button className="w-full" onClick={onClose}>
          {t('common.done')}
        </Button>
      </SheetFooter>
    </SheetContent>
  );
};
